import React, { FC } from 'react';
import { RefundPricesFragment } from '@websky/graphql';
import cn from 'classnames';
import RefundPaper from '../../../../Refund/Components/RefundPaper/RefundPaper';
import { Money as MoneyType } from '../../../../types';
import Details from './Details/Details';
import { PriceDetailsVariant } from '../types';
import ShortDetails from './ShortDetails/ShortDetails';
import TotalRefund from './TotalRefund/TotalRefund';
import { useTheme } from '../../../../theme';
import ExtendedDetails from './ExtendedDetails/ExtendedDetails';

export interface Props {
	className?: string;
	prices: RefundPricesFragment;
	ticketPrice?: MoneyType;
	variant?: PriceDetailsVariant;
}

const PriceDetails: FC<Props> = ({ className, prices, variant = 'details', ticketPrice }) => {
	const { PriceDetails: css } = useTheme('PriceDetails');

	return (
		<RefundPaper className={cn(css.root, className)}>
			{variant === 'details' && <Details prices={prices} />}
			{variant === 'short-details' && <ShortDetails prices={prices} ticketPrice={ticketPrice} />}
			{variant === 'only-total' && <TotalRefund price={prices.priceToPay} />}
			{variant === 'extended-details' && <ExtendedDetails prices={prices} />}
		</RefundPaper>
	);
};

export default PriceDetails;
